import SelectInsuranceTypeModal from './SelectInsuranceTypeModal';
export default SelectInsuranceTypeModal;
